import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { VerificationOverviewPage } from './VerificationOverviewPage';
import AdminVerificationDashboard from './AdminVerificationDashboard';
import AdminVerificationDemo from './AdminVerificationDemo';
import SimpleVerificationTest from './SimpleVerificationTest';
import UltraSimpleVerificationTest from './UltraSimpleVerificationTest';
import ApiTestPage from './ApiTestPage';

// 📋 NEW: Progressive verification form
import { DriverVerificationForm } from './DriverVerificationForm';

export const VerificationPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="overview" replace />} />
      {/* Use the proper verification overview page */}
      <Route path="overview" element={<VerificationOverviewPage />} />
      <Route path="overview/demo" element={<AdminVerificationDemo />} />
      <Route path="admin" element={<AdminVerificationDashboard />} />
      <Route path="demo" element={<AdminVerificationDemo />} />
      <Route path="test" element={<SimpleVerificationTest />} />
      <Route path="ultra" element={<UltraSimpleVerificationTest />} />
      <Route path="api-test" element={<ApiTestPage />} />
      
      {/* 📋 NEW: Progressive verification form for users */}
      <Route path="form" element={<DriverVerificationForm />} />
      <Route path="driver" element={<DriverVerificationForm />} />
    </Routes>
  );
};